export interface Bonus {
  number: string
  title: string
  description: string
  value: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Banco de Rúbricas Listas para Usar',
    description:
      'Criterios claros por nivel para evaluar sin dudar ni improvisar.',
    value: '$6.990',
    cover:
      'https://cdn.magicpatterns.com/uploads/mNJNT2uiab1Xt33XbNYnf7/ChatGPT_Image_15_sept_2026,_13_06_23.png',
  },
  {
    number: '2',
    title: 'Calendario Escolar del Arte 2027',
    description:
      'Efemérides, artistas y proyectos sugeridos mes por mes del ciclo lectivo.',
    value: '$6.990',
    cover:
      'https://cdn.magicpatterns.com/uploads/jVTkGfHmfp6sNR8XsPbhKJ/ChatGPT_Image_15_sept_2026,_13_06_26.png',
  },
  {
    number: '3',
    title: 'Arte con Materiales Económicos',
    description:
      'Proyectos completos con lo que ya tenés en el aula, sin gastar de más.',
    value: '$6.990',
    cover:
      'https://cdn.magicpatterns.com/uploads/uVAzpRTieBK6U6bFkXByAF/ChatGPT_Image_15_sept_2026,_13_06_27.png',
  },
  {
    number: '4',
    title: 'Grandes Artistas Latinoamericanos',
    description:
      'Fichas y actividades sobre referentes de la región, listas para dar.',
    value: '$6.990',
    cover:
      'https://cdn.magicpatterns.com/uploads/gyriHrTA2HGYSPTVXmpaxA/ChatGPT_Image_15_sept_2026,_13_07_18.png',
  },
  {
    number: '5',
    title: 'Plantillas de Portafolio del Alumno',
    description:
      'Formatos imprimibles para que cada alumno registre su proceso creativo.',
    value: '$6.990',
    cover:
      'https://cdn.magicpatterns.com/uploads/rJLakZJn9vj7SZvyvvMgzy/ChatGPT_Image_15_sept_2026,_13_08_26.png',
  },
]
